import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*() {
  return yield oncallFetch("/api/oncall/partners/engineers/list", {});
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/engineers/list.js